export default defineNuxtRouteMiddleware((to) => {
  const routePath = to.path
    .replace(/^\/(?!de)(en)(?=\/|$)/, "/")
    .replace(/^\/+/, "/");

  if (routePath === "/" && !to.path.endsWith("/")) {
    return navigateTo(to.path + "/", { redirectCode: 301 });
  }
});
